import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslationService } from '@nesea/ngx-ui-kit/shared';
import { MainContainerComponent } from '@core/components/main-container/main-container.component';

@Component({
  selector: 'nsf-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MainContainerComponent
  ]
})
export class AppComponent {

  private _translationDateService: TranslationService = inject(TranslationService);

}
